import LocationDeleteButton from "./location-delete-button";

export default LocationDeleteButton;